import {
  Box,
  Paper,
  Title,
  createStyles,
  Grid,
  Flex,
  Button,
  Text,
  CloseButton,
  Modal,
  Skeleton,
  Loader,
  Center,
} from "@mantine/core";

import { useMedplum } from "@medplum/react";

import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import { PatientDetails } from "./Card";
import { QuestDetails } from "./Details";
import { IconCross, IconLetterX, IconPhone } from "@tabler/icons-react";
import { Questions } from "./Questions";
import { useEffect, useRef, useState } from "react";
import { ModalContent } from "./ModalContent";
import { useLocation, useParams } from "react-router-dom";

import {
  createQtrResponse,
  extractQuestionnaireIds,
  extractQuestionnareResource,
  getAddress,
  getCardsDetails,
  getPatientDetails,
  getQuestionnaireResource,
  getQuestionnaireResponse,
  matchQuestionsAndAnswers,
  retryCall,
  startCall,
} from "./Service";
import { getPatientName } from "../Eligibility/EligibiltyService";
import { formatDateTime } from "@medplum/core";
import crossBlue from "../../assets/img/blueCross.svg";
import crossWhite from "../../assets/img/whiteCross.svg";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";
import { Summary } from "../AIRecipes/SummaryAi";
import { connect } from "http2";
import {
  connectCommSocket,
  connectQnrResSocket,
  extractMessages,
  fetchCommunicationResource,
} from "./CommunicationServices";
import { ChatQuestion } from "./ChatQuestion";
import ChatUI from "./ChatNew";
import { Questionnaire } from "@medplum/fhirtypes";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  box1: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  cardsBox: {
    display: "flex",
    borderRadius: "8px",
    border: "1px solid #EDEDED",
    padding: "16px 12px 16px 12px",
    gap: "12px",
    flexDirection: "column",
  },
  box3: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
  questRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  text: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#262930",
    alignItems: "center",
  },
}));

export const QuestionnaireDetails = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const location = useLocation();

  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>("details");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [ids, setIds] = useState<any>([]);
  const [categoryName, setCategoryName] = useState<string>();
  const [questionnaireResponse, setquestionnaireResponse] = useState<any>();
  const [questionnaire, setQuestionnaire] = useState<any>();
  const [patientDetails, setpatientDetails] = useState<any>();
  const [cardsDetails, setCardsDetails] = useState<any>([]);
  const [selectedCardIndex, setSelectedCardIndex] = useState<number | null>(
    null
  );
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [questionnareResponseId, setQuestionnareResponseId] = useState<any>();
  const [selectedCardDetails, setSelectedCardDetails] = useState<any>(null); // New state to store card details
  const [buttons, setButtons] = useState<any>([]);
  const [answers, setAnswers] = useState<any>([]);
  const [isModalLoading, setIsModalLoading] = useState<boolean>(false);
  const [messages, setMessages] = useState<any>([]);
  const [form, setForm] = useState<any>([]);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [qtrResponse, setQtrResponse] = useState<any>(null);
  const [qtrId, seQtrId] = useState<any>();
  const [chatLaunch, setChatLaunch] = useState<string>('qnr');
  const [filteredLinkIds, setFilteredLinkIds] = useState<any>([]);
  const [qtrResponseShowChat, setQtrResponseShowChat] =
    useState<boolean>(false);
  const [qtrResponseId, setQtrResponseId] = useState<any>();
  const [questionText, setQuestionText] = useState<any>();
  const [chatContext, setChatContext] = useState<'education' | 'medical-assistant' | ''>('');


  const [checkboxes, setShowCheckBoxes] = useState<boolean>(false);
  const [selctedMode, setSelectedMode] = useState<any>("Voice Bot");
  const { patientID } = useParams();
  const ws = useRef<WebSocket | null>(null);
  const commWS = useRef<WebSocket | null>(null);
  const commToken = useRef<string | null>(null);
  const commSocketOpened = useRef<boolean>(false);
  const selectedTabRef = useRef(selectedTab);

  useEffect(() => {
    selectedTabRef.current = selectedTab;
    const qtrResID = location.state?.qtrResID;
    if (qtrResID) {
      setQtrResponseId(qtrResID);
      setChatLaunch('education');
      setQtrResponseShowChat(true);
    }
  }, [selectedTab]);

  useEffect(() => {
    let pendingIndex = null;
    cardsDetails.forEach((card: any, index: number) => {
      if (card?.status === "pending") pendingIndex = index;
    });
    if (pendingIndex !== null) {
      handleCardClick(pendingIndex, cardsDetails[pendingIndex]);
    }
  }, [cardsDetails]);

  useEffect(() => {

  }, [messages]);

  useEffect(() => {
    if (selectedTab === "Question") return;
    fetchPatientDetails();
    idsFetched();

    setLoading(true);
    fetchQuestionnareRes(true);

  }, []);

  useEffect(() => {
    cardDetails();
  }, [questionnaire, questionnaireResponse, ids]);

  useEffect(() => {
    if (commToken.current && !commSocketOpened.current) {
      commSocketOpened.current = true;
      connectCommSocket(commWS, setMessages, commToken.current, answers);
      commToken.current = null;
    }
  }, [answers]);
  useEffect(() => {
    if (qtrResponseShowChat === true) {
      setSelectedMode("Chat Bot");
    }
  }, [qtrResponseShowChat]);

  const handleCardClick = (index: number, details: any) => {
    if (!buttons.some((btn: any) => btn.index === index)) {
      setButtons((prevButtons: any) => [
        ...prevButtons,
        { text: `Questionnaire ${index + 1}`, index },
      ]);
    }
    setQuestionnareResponseId(details?.qrid);
    setSelectedCardIndex(index);
    setSelectedCardDetails(details);
    setSelectedTab("Question");
    handleButtonClick(index);
  };
  // const handleSelectChangeInParent = (value: string) => {
  //   setSelectedMode(value);
  // };
  const handleEnableSubmit = () => {
    setIsSubmitEnabled(true);
  };
  const handleSubmitDetails = (e: any) => {
    setQtrResponse(e);
  };
  const handleSubmitButtonClick = async () => {
    setSubmitting(true);
    const response = await createQtrResponse(medplum, qtrResponse);
    setIsSubmitted(true);
    setSubmitting(false);
    setIsSubmitEnabled(false);
  };

  const fetchQuestionnareRes = async (direct: boolean = false): Promise<any> => {

    if (selectedTabRef.current === "Question" && !direct) return;
    const res = await getQuestionnaireResponse(medplum, 200, 1, [
      `Patient/${patientID}`,
    ]).then((res) => {
      setquestionnaireResponse(res);

      const questionnaireIds = extractQuestionnaireIds(res as any);
      const qnrRes = extractQuestionnareResource(
        medplum,
        200,
        1,
        questionnaireIds
      ).then((res) => {
        setQuestionnaire(res);
        setLoading(false);
        if (res?.length && direct) {
          const filteredQnrs = res?.filter((item) => item?.code?.[0]?.code === categoryName);
          if (filteredQnrs?.length) {
            setIds(filteredQnrs?.map((item) => item?.id));
            location.state = {
              ids: filteredQnrs?.map((item) => item?.id),
              categoryName: categoryName
            }
          }
        }
      });
    });

    return res
  };
  const idsFetched = () => {
    const fetchIds = location.state;
    if (!fetchIds) return;
    if (fetchIds?.ids) {
      setQtrResponseId(fetchIds?.ids);
      setQtrResponseShowChat(fetchIds?.qtrResponse);
    }
    setIds(fetchIds?.filterIds);
    setCategoryName(fetchIds?.componentHeading);
    const chatContext = fetchIds?.chatContext;
    if (chatContext) setChatContext(chatContext);
  };

  const cardDetails = () => {
    const cd = getCardsDetails(questionnaire, questionnaireResponse);
    const filteredData = cd.filter((item) => ids?.includes(item.qid));
    setCardsDetails(filteredData);

    //  setCardsDetails((prevCardsDetails:any) => {
    //    const updatedCardsDetails = [...prevCardsDetails];
    //    let newDataAdded = false;

    //    // Check if there is any new data to append
    //    filteredData.forEach((newItem) => {
    //      const existingItem = prevCardsDetails.find(
    //        (item:any) => item.qrid === newItem.qrid
    //      );
    //      if (!existingItem) {
    //        updatedCardsDetails.push(newItem);
    //        newDataAdded = true;
    //      }
    //    });

    //    // If no new data was appended, update the last item
    //    if (
    //      !newDataAdded &&
    //      updatedCardsDetails.length > 0 &&
    //      filteredData.length > 0
    //    ) {
    //      const lastCardDetail =
    //        updatedCardsDetails[updatedCardsDetails.length - 1];
    //      const matchingFilteredData = filteredData.find(
    //        (item) => item.qrid === lastCardDetail.qrid
    //      );

    //      if (matchingFilteredData) {
    //        updatedCardsDetails[updatedCardsDetails.length - 1] =
    //          matchingFilteredData;
    //      }
    //    }

    //    return updatedCardsDetails;
    //  });

    if (selectedCardIndex !== null) {
      const questions = matchQuestionsAndAnswers(
        filteredData[selectedCardIndex]
      );
      setAnswers(questions);
    }
  };



  const fetchPatientDetails = () => {
    getPatientDetails(medplum, patientID).then((res) => {
      setpatientDetails(res);
    });
  };

  const handleButtonClick = (index: number) => {
    setSelectedCardIndex(index);
    setSelectedTab("Question");
    setQuestionnareResponseId(cardsDetails[index]?.qrid);
    const questions = matchQuestionsAndAnswers(cardsDetails[index]);
    setAnswers(questions);
  };

  const handleRemoveButton = (index: number) => {
    setButtons((prevButtons: any) =>
      prevButtons.filter((btn: any) => btn.index !== index)
    );
    if (selectedCardIndex === index) {
      setSelectedCardIndex(null);
      setSelectedTab("details");
    }
  };


  const handleStartCall = async (phoneNumber: string, linkIds: any, questionsText: any) => {
    //Question text also gets rearranged, re-sort it
    const sortedQtext = questionsText.sort((a: any, b: any) => {
      const numA = parseInt(a?.linkId?.split('-')[1]);
      const numB = parseInt(b?.linkId?.split('-')[1]);
      return numA - numB;
    });
    setIsModalLoading(true);
    const callOb = await startCall(
      medplum,
      patientID ?? "",
      ids[0],
      phoneNumber,
      linkIds,
      questionsText,
      categoryName
    );
    await fetchQuestionnareRes(true);
    if (callOb?.socket?.qnrResToken)
      connectQnrResSocket(
        ws,
        setquestionnaireResponse,
        callOb?.socket?.qnrResToken
      );
    if (callOb?.socket?.commToken)
      commToken.current = callOb?.socket?.commToken;
    // connectCommSocket(commWS, setMessages, callOb?.socket?.commToken, answers);

    setQuestionnareResponseId(null);
    setIsModalLoading(false);
    setShowModal(false);
    setShowCheckBoxes(false);
  };

  const handleRetry = async (qResId: string) => {
    const callOb = await retryCall(medplum, qResId);
    if (callOb?.socket?.qnrResToken)
      connectQnrResSocket(
        ws,
        setquestionnaireResponse,
        callOb?.socket?.qnrResToken
      );

    if (callOb?.socket?.commToken)
      commToken.current = callOb?.socket?.commToken;
    connectCommSocket(commWS, setMessages, callOb?.socket?.commToken, answers);
  };

  return (
    <>
      <Paper className={classes.default} >
         <Box className={classes.box1}>
          <Box className={classes.box3}>
            <CustomBreadcrumbs />
            {!chatContext && <Box sx={{ display: "flex", flexDirection: "row", gap: "12px" }}>
              {" "}
              <Button variant="outline" disabled>
                <Text color="#262930"> Schedule a call</Text>
              </Button>
              <Button
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Start Now
              </Button>
            </Box>}
          </Box>
          <Box>
            {loading ? (
              <>
                <Skeleton height={50} circle mb="xl" />
                <Skeleton height={8} radius="xl" />
                <Skeleton height={8} mt={6} radius="xl" />
                <Skeleton height={8} mt={6} width="70%" radius="xl" />
              </>
            ) : (
              <PatientDetails
                name={getPatientName(patientDetails?.[0]?.name)}
                dob={patientDetails?.[0]?.birthDate}
                mobile={
                  patientDetails?.[0]?.telecom?.find(
                    (tel: any) => tel.system === "phone"
                  ).value
                }
                address={getAddress(patientDetails?.address) ?? "--"}
                email={
                  patientDetails?.[0]?.telecom?.find(
                    (tel: any) => tel.system === "email"
                  )?.value
                }
                gender={patientDetails?.[0]?.gender}
              />
            )}
          </Box>
          <Box className={classes.box3}>
            <Box className={classes.buttonBox}>
              <Button
                onClick={() => {
                  setSelectedTab("details");
                }}
                variant={selectedTab === "details" ? "filled" : "outline"}
              >
                {!chatContext && "Details"}
                {chatContext && "AI Chat"}
              </Button>
              {buttons.map((button: any) => (
                <Button
                  variant={
                    selectedCardIndex === button.index &&
                      selectedTab.includes("Question")
                      ? "filled"
                      : "outline"
                  }
                  key={button.index}
                  onClick={() => {
                    setSelectedTab("Question");
                    handleButtonClick(button.index);
                  }}
                  rightIcon={
                    selectedCardIndex === button.index &&
                      selectedTab === "Question" ? (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveButton(button.index);
                        }}
                      >
                        <img src={crossWhite} alt="X" />
                      </Box>
                    ) : (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveButton(button.index);
                        }}
                      >
                        <img src={crossBlue} alt="X" />
                      </Box>
                    )
                  }
                >
                  {button.text}
                </Button>
              ))}
            </Box>
          </Box>
          {selectedTab === "details" && (
            <>
              <Box className={classes.cardsBox}>
                {selctedMode !== "Chat Bot" && (
                  <Box className={classes.questRow}>
                    <Box className={classes.text}>
                      <Text>Questionnaire details</Text>
                    </Box>
                    {selctedMode === "Create Form" && (
                      <Box>
                        <Button
                          disabled={!isSubmitEnabled}
                          onClick={handleSubmitButtonClick}
                        >
                          {submitting ? (
                            <Loader size={`sm`} color="white" />
                          ) : (
                            `Submit`
                          )}
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}

                {selctedMode === "Create Form" && (
                  <Box>
                    <ChatQuestion
                      isSubmitted={isSubmitted}
                      data={form}
                      qtrId={ids[0]}
                      onEnableSubmit={handleEnableSubmit}
                      onResponseGenerated={handleSubmitDetails}
                    />
                  </Box>
                )}
                {selctedMode === "Chat Bot" && (
                  // <PatientNotFound patient="Chat" />
                  <ChatUI
                    patientName={getPatientName(patientDetails?.[0]?.name)}
                    dob={patientDetails?.[0]?.birthDate}
                    mobile={
                      patientDetails?.[0]?.telecom?.find(
                        (tel: any) => tel.system === "phone"
                      ).value
                    }
                    patientId={patientID}
                    linkedIds={filteredLinkIds}
                    qtrId={qtrId?.[0] ?? ""}
                    questionText={questionText}
                    qtrResponseIdForChat={qtrResponseId ?? ""}
                    launchType={chatLaunch}
                    chatContext={chatContext}
                  />
                )}

                {loading && selctedMode === 'Voice Bot' ? (
                  <Box mt={20}>
                    <Skeleton height={8} radius="xl" />
                    <Skeleton height={8} mt={6} radius="xl" />
                    <Skeleton height={8} mt={6} width="70%" radius="xl" />
                  </Box>
                ) : (
                  <>
                    {/* {cardsDetails.length === 0 && (
                      <>
                        <PatientNotFound patient="This Category's Questionnaire" />
                      </>
                    )} */}
                    {selctedMode === "Voice Bot" && (
                      <Grid>
                        {cardsDetails.map((details: any, index: any) => (
                          <Grid.Col
                            span={"auto"}
                            onClick={() => handleCardClick(index, details)}
                          >
                            {" "}
                            <QuestDetails
                              status={details?.status}
                              Questionnaire={details?.questionnaire}
                              date={formatDateTime(details?.date).split(",")[0]}
                              numberOfQuestions={details?.numberOfQuestions}
                              additionalDetails={
                                details?.answer?.filter((ans: any) => ans.text)
                                  .length ?? "--"
                              }
                            />
                          </Grid.Col>
                        ))}
                      </Grid>
                    )}
                  </>
                )}
              </Box>
            </>
          )}
          {selectedTab === "Question" && (
            <>
              <Grid>
                <Grid.Col span={"auto"}>
                  <Questions
                    questions={answers}
                    questionnareResponseId={questionnareResponseId}
                    patientName={getPatientName(patientDetails?.[0]?.name)}
                    messages={messages}
                    setMessages={setMessages}
                    handleRetry={handleRetry}
                  />
                </Grid.Col>
              </Grid>
            </>
          )}
        </Box>
        {showModal && (
          <Modal
            opened={showModal}
            onClose={() => {
              setShowModal(false);
            }}
            withCloseButton={false}
            size="69%"
          >
            {isModalLoading && (
              <Center mih="400px">
                <Loader variant="dots" >Fetching Patients details</Loader>
              </Center>
            )}
            {!isModalLoading && (
              <ModalContent
                patientId={patientID}
                categoryName={categoryName}
                // onchange={handleSelectChangeInParent}
                mobileNumber={
                  patientDetails?.[0]?.telecom?.find(
                    (tel: any) => tel.system === "phone"
                  ).value
                }
                // onchange={() => {
                //   setShowCheckBoxes(true);
                // }}
                showCheckboxes={checkboxes}
                cancel={() => {
                  setShowModal(false);
                  setShowCheckBoxes(false);
                }}
                onSubmit={handleStartCall}
                checkBoxLabels={ids}
                onChatClick={(
                  val: any,
                  filterIds: any,
                  questionText: any,
                  checkBoxLabels: any
                ) => {
                  setShowModal(false);
                  setQuestionText(questionText);
                  const linkIdSet = new Set(filterIds);
                  setFilteredLinkIds(filterIds);
                  seQtrId(checkBoxLabels);

                  const reorderedArray2 = questionText
                    .filter((item: any) => linkIdSet.has(item.linkId)) // Filter out items not in array1
                    .sort(
                      (a: any, b: any) =>
                        filterIds.indexOf(a.linkId) -
                        filterIds.indexOf(b.linkId)
                    );
                  setForm(reorderedArray2);
                  setSelectedMode(val);
                }}
              />
            )}
          </Modal>
        )}
      </Paper>
    </>
  );
};
